import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue';
import useZIndex from '../../../../hooks/useZIndex';
import '../../../../directives/vTap';

interface Props {
  value: boolean;
  title?: string;
  confirmButton?: string;
  cancelButton?: string;
  closeOnClickModal?: boolean;
  appendToBody?: boolean;
  appendToRoomContainer?: boolean;
  modal?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DialogH5',
  props: {
    value: { type: Boolean, default: false },
    title: { default: '' },
    confirmButton: { default: '' },
    cancelButton: { default: '' },
    closeOnClickModal: { type: Boolean, default: true },
    appendToBody: { type: Boolean, default: false },
    appendToRoomContainer: { type: Boolean, default: false },
    modal: { type: Boolean, default: false }
  },
  emits: ['input', 'close', 'confirm', 'cancel'],
  setup(__props: any, { emit }) {

const props = __props as { value: boolean, title: string, confirmButton: string, cancelButton: string, closeOnClickModal: boolean, appendToBody: boolean, appendToRoomContainer: boolean, modal: boolean }

const visible = ref(false);
const overlayContainerStyle = ref({});
const { nextZIndex } = useZIndex();
const dialogRef = ref();
const hasTitle = computed(() => props.title !== '');




watch(
  () => props.value,
  (val) => {
    visible.value = val;
  },
);

watch(visible, (val) => {
  if (val) {
    overlayContainerStyle.value = { zIndex: nextZIndex() };
    if (props.appendToRoomContainer) {
      document.getElementById('roomContainer')?.appendChild(dialogRef.value);
    }
  }
});

function handleConfirm() {
  emit('confirm');
  handleClose();
}
function handleCancel() {
  emit('cancel');
  handleClose();
}

function handleClose() {
  visible.value = false;
  emit('input', false);
  emit('close');
}

function handleOverlayClick(event: any) {
  if (!props.closeOnClickModal) {
    return;
  }
  if (event.target !== event.currentTarget) {
    return;
  }
  handleClose();
}

return { __sfc: true,visible, overlayContainerStyle, nextZIndex, dialogRef, hasTitle, props, emit, handleConfirm, handleCancel, handleClose, handleOverlayClick }
}

})